<template>
  <div>
    <div>
      <div v-if="loading">
        <div class="text-center">
          <v-progress-linear
            color="info"
            height="10"
            indeterminate
            striped
          ></v-progress-linear>
        </div>
      </div>
      <template v-else>
        <div class="vuse-content-wrapper" v-if="!dialog_setup" >
          <v-card-title primary-title class="py-0">
            <div class="text-h5">Impostazioni</div>
            <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip> 
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_tutorial=true">
                    <v-icon color="info">mdi-cast-education</v-icon>
                  </v-btn>
                </template>
                <span>Tutorial</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_setup=true">
                    <v-icon color="info">mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <span>Setup</span>
              </v-tooltip>                            
          </v-card-title>
          <v-container fluid>
            <v-sheet elevation="8">
              <v-tabs
                elevation="8"
                color="info"
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
              >
                <v-tabs-slider color="info"></v-tabs-slider>
                <template v-for="t in tabs" >
                  <v-tab
                    :key=t.id
                    :href="'#'+t.id"
                    class="text-subtitle-1"
                  >
                    {{t.name}}
                  </v-tab>
                  <v-tab-item :key=t.id :id="t.id">
                    <v-row>
                      <v-col cols="12" :md="Math.max(12/t.components.length,t.min)" v-for="(c,ci) in t.components" :key="ci" :class="ci==1%2?'py-2 pr-2':'pl-2 py-2'">
                        <v-card flat>
                          <component :is="c"></component>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item>
              </v-tabs>
            </v-sheet>
          </v-container>
        </div>
      </template>
    </div>
    <dialog-instruction v-model="dialog_instruction" />
    <dialog-tutorial v-model="dialog_tutorial"  />
    <dialog-connection-error :number="settings.phoneTechnician" v-model="dialog_connection_error" />
    <dialog-setup @save="saveItem" :loading="loading" v-model="dialog_setup" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import allSlots                     from "./Partials/AllSlots";
//import allShifts                from "./Partials/AllShifts";
import allSlotsParametersGlobal     from "./Partials/AllSlotsParameters_Global";
import allTables                    from "./Partials/AllTables";
import allCombinations              from "./Partials/AllCombinations";
import allLocationsTable            from "./Partials/AllLocationsTable";
import allHallsTable                from "./Partials/AllHallsTable";
import allMealsTable                from "./Partials/AllMealsTable";
import allShiftsTable               from "./Partials/AllShiftsTable";
import allOptions                   from "./Partials/AllOptions";
import allModules                   from "./Partials/AllModules"
import closedWeekly                 from "./Partials/ClosedWeekly";
import closedPeriods                from "./Partials/ClosedPeriods";
import account                      from "./Partials/Account";
import invoices                     from "./Partials/Invoices";
import pictures                     from "./Partials/Pictures";
import logos                        from "./Partials/Logos";
import allFaqs                      from "./Partials/AllFAQS";
import allRequests                  from "./Partials/AllRequests";
import allFoodStyle                 from "./Partials/AllFoodStyle";
import allSlotsParametersExceptions from "./Partials/AllSlotsParametersExceptions";
import allSlotsParameters           from "./Partials/AllSlotsParameters";
import allSlotsParametersGlobal2    from "./Partials/AllSlotsParameters_Global2";
import allHostnames                 from "./Partials/AllHostnames";
import whatsApp                     from "./Partials/WhatsApp";
import directBooking                from "./Partials/DirectBooking";
import subUsers                     from "./Partials/SubUsers";
import voiceMail                    from "./Partials/VoiceMail";
import avatarAI                     from "./Partials/AvatarAI";

import dialogInstruction            from "./Dialogs/instruction";
import dialogTutorial               from "./Dialogs/tutorial"
import dialogConnectionError        from "./Dialogs/connectionError"
import dialogSetup                  from "./Dialogs/initialSetup"

/*
import tablesByCovers from "./Partials/TablesByCovers";*/
export default {
  components: { allSlots, allSlotsParametersGlobal, allTables, allCombinations, allLocationsTable, allHallsTable, allMealsTable, allShiftsTable, allOptions, allRequests, allFoodStyle,
                allFaqs, allModules, closedWeekly, closedPeriods, account, invoices, logos, pictures, allSlotsParametersExceptions,allSlotsParameters,allSlotsParametersGlobal2,allHostnames, dialogInstruction,dialogTutorial,
                dialogConnectionError,dialogSetup,subUsers,voiceMail,avatarAI,whatsApp,directBooking
              },
  computed :{
      ...mapGetters(["settings"]),
  },
  data() {
    return {
      page: "Settings",
      loading:true,
      errorNumber:'3203023832',
      dialog_setup:true,
      dialog_instruction:false,
      dialog_tutorial:false,
      dialog_connection_error:false,
      tab:null,
      tabs:[
            {"id":"tables","name":"Aree","components":["allLocationsTable","allMealsTable","allHallsTable","allShiftsTable"],"min":6},

            {"id":"allslots","name":"Slots","components":["allSlots"],"min":6},
            {"id":"allslotsparametersglobal","name":"Parametri Slots","components":["allSlotsParametersGlobal"],"min":6},
            {"id":"allslotsparametersexceptions","name":"Eccezioni","components":["allSlotsParametersExceptions"],"min":6},
            
            {"id":"alltables","name":"Tavoli","components":["allTables"],"min":6},
            {"id":"allcombinations","name":"Combinazioni","components":["allCombinations"],"min":6},
            
            {"id":"closures","name":"Chiusure","components":["closedWeekly","closedPeriods"],"min":6},
            {"id":"alloptions","name":"Opzioni","components":["allOptions"],"min":6},
            
            {"id":"foodstyle&requests","name":"Food Styles & Richieste","components":["allFoodStyle","allRequests"],"min":6},
            {"id":"faqs","name":"FAQS","components":["allFaqs"],"min":6},
            
            
            {"id":"whatsapp","name":"WhatsApp","components":["whatsApp"],"min":4},
            {"id":"directbooking","name":"DirectBooking","components":["directBooking"],"min":6},
            
            {"id":"voicemail","name":"Segreteria","components":["voiceMail"],"min":6},
            //{"id":"avatar","name":"Avatar","components":["avatarAI"],"min":6},
            {"id":"allslotsparameters","name":"Parametri Slots","components":["allSlotsParameters"],"min":6},
            //{"id":"allslotsparametersglobal2","name":"Parametri Slots G2","components":["allSlotsParametersGlobal2"],"min":6},
            //{"id":"domain","name":"Dominio","components":["allHostnames"],"min":6},
            //{"id":"services","name":"Servizi","components":["allModules"],"min":6},
            {"id":"subusers","name":"Accounts","components":["subUsers"],"min":6},
            {"id":"account","name":"Anagrafica","components":["account"],"min":4},
            {"id":"invoicing","name":"Fatture","components":["invoices"],"min":12},
            //{"id":"pictures","name":"Immagini","components":["logos","pictures"],"min":6},

          ],
      //editedItem:{fromLunch:'12:00',toLunch:'14:00',durationLunch:60,stepLunch:15,fromDinner1:'19:00',toDinner1:'20:00',durationDinner1:90,stepDinner1:30,fromDinner2:'20:30',toDinner2:'22:30',durationDinner2:120,stepDinner2:30,t1:2,t2:2,t3:2,covers:30,tables:15},
      //editedItem2:{areaNames:null,hallName:[],mealNames:null,shiftName:[],from:[],to:[],duration:[],step:[],max1:[],max2:[],max3:[]}, 
      editedItem2:null
      };
    },
    created(){
      this.getData('a');
      this.$store.dispatch("setUser",JSON.parse(localStorage.getItem('user')));
      /*
      if (!this.user.username){
        this.$router.push('/auth/login').catch(() => {});
      }  */
      /*
      this.user.username=JSON.parse(localStorage.getItem('user')).username;
      this.user.level=parseInt(JSON.parse(localStorage.getItem('user')).level);
      this.user.avatar=JSON.parse(localStorage.getItem('user')).avatar;
      */
    },
    methods:
    {
      async getData(origin)
      {
        this.loading=true;
        try{
            const payload=JSON.stringify({"action":"AllLocationsTable_get"});
            const res = await this.$http.post('/settings/settings.php', payload );
            console.log(275,res);            
            switch (res.data.errorid)
            {
              case '0':
                  sessionStorage.setItem('jwt', res.data.jwt);
                  this.items=res.data.payloads.allLocationsTable;
                  this.dialog_setup=this.items?false:true;
                  this.loading=false;
                  console.log(315,this.items)
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }
            this.loading= false;
        } catch(e)
        {
            this.loading= false;

        }
      },
    async saveItem(p)
    {
        console.log(144,p)
        //this.editedItem2.closedOn=this.editedItem2.closedOn?this.editedItem2.closedOn.join(','):null;
        this.loading_update=true;
        p.WA_Logo=p.brand
        let payload={"action":"saveItem","table":"SetUp","payload":p};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.payloads.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
        this.editedItem2={}
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.payloads.message;
            this.getData('refresh')

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.payloads.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
          console.log(e);
          this.loading= false;
          this.dialog_connection_error=true;
        }
    },          
  }
}
</script>